import {SocketIf, VirtualEventConfig, Participant} from "socket_if"

export default (connection, store, dispatcher) => {
  const event = VirtualEventConfig.event

  connection.on(event.server_client.connect, () => {
    console.log("init")
    dispatcher.authParticipants()
  })

  connection.on(event.server_client.init_participants, text => {
    console.log("init participants")
    const response = SocketIf.parse(text)
    store.dispatch("participants/convertAll", response)
  })

  connection.on(event.server_client.init_direct_messages, text => {
    console.log("init dm")
    const response = SocketIf.parse(text)
    store.dispatch("directMessages/convertAll", response)
  })

  connection.on(event.server_client.init_room_messages, text => {
    console.log("init rm")
    const response = SocketIf.parse(text)
    store.dispatch("roomMessages/convertAll", response)
  })

  connection.on(event.server_client.update_participants, text => {
    console.log("received participants")
    const response = SocketIf.parse(text)
    console.log(response)
    store.dispatch("participants/updateParticipant", response)
  })

  connection.on(event.server_client.update_direct_messages, text => {
    console.log("received dm")
    const response = SocketIf.parse(text)
    store.dispatch("directMessages/setMessages", response.body)
  })

  connection.on(event.server_client.update_room_messages, text => {
    console.log("received rm")
    const response = SocketIf.parse(text)
    store.dispatch("roomMessages/setMessages", response.body)
  })

  connection.on(event.server_client.delete_room_messages, text => {
    console.log("received rm delete")
    const response = SocketIf.parse(text)
    store.dispatch("roomMessages/deleteMessages", response.body)
  })

  connection.on(event.server_client.update_notice, text => {
    console.log("received notice")
    const response = SocketIf.parse(text)
    store.dispatch("notice/setNotice", response.body)
  })

  connection.on(event.server_client.update_per_live_questionnaire, text => {
    console.log("received live questionnaire")
    const response = SocketIf.parse(text)
    store.dispatch("liveQuestionnaire/setQuestionnaires", response.body)
  })

  // マルチエラー検出時
  connection.on(event.server_client.multi_access_error, text => {
    console.log("multi error")
    const response = SocketIf.parse(text)
    store.dispatch("auth/logout", true)
  })

  // 接続時
  connection.on(event.server_client.connect, text => {
    // 接続成功時にreconnectionをfalseにする(再接続しないように設定する)
    connection.io.reconnection(false)
    store.commit("requestReload/setDisconnected", connection.disconnected)
  })

  // 切断時
  connection.on(event.server_client.disconnect, text => {
    switch (text) {
      case "io server disconnect": // サーバーがsocket.disconnect()を使用してソケットを強制的に切断しました
      case "ping timeout": // サーバーがpingTimeout範囲内で応答しませんでした
      case "transport close": // 接続が閉じられました（例：ユーザーが接続を失った、またはネットワークがWiFiから4Gに変更された）
      case "transport error": // 接続でエラーが発生しました（例：HTTPロングポーリングサイクル中にサーバーが強制終了されました）
        store.commit("requestReload/setDisconnected", connection.disconnected)
        store.commit("requestReload/setMessage", "サーバーとの接続が失われました。<br>画面を再読み込みしてください。")
        break
    }
  })
}
